import { toast } from "react-toastify";
import { API_VEHICULOS } from "../../views/MainLayout/components/shared/services/vehiculos";
import { setErrorMessage } from "../../views/MainLayout/components/shared/helpers/functionalities";

const initialDashboard = [];

export const dashboardVehiculosReducer = (state = initialDashboard, action) => {
    switch(action.type){
        case "vehiculos/fullfilled": {
            return action.payload;
        }
        case "vehiculo/fullfilled": {
            const vehiculosList = state.vehiculos;
            const index = vehiculosList.findIndex((vehiculo) => vehiculo.bastidor === action.payload.bastidor);
            const newVehiculoInfo = {...action.payload.vehiculo, ...vehiculosList[index]};
            vehiculosList.splice(index, 1, newVehiculoInfo);

           return {
                ...state,
                vehiculos: vehiculosList,
            }

        }
        default:
            return state
    }
}

export const fetchDashboardVehiculos = (page, search) => async dispatch => {
    dispatch({type: 'loading/set', payload: true});

    try {
        const response = await API_VEHICULOS.getVehiculos(page, search);
        const data = await response.data;
        dispatch({type: 'vehiculos/fullfilled', payload: data });
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const fetchDashboardVehiculo = (bastidor) => async dispatch => {
    dispatch({type: 'loading/set', payload: true});

    try {
        const fechasAlmacenamiento = await API_VEHICULOS.getFechasAlmacenamiento(bastidor)
        const response = await API_VEHICULOS.getVehiculo(bastidor)
        .catch(function (error) {
            toast.error(setErrorMessage(error))
            dispatch({type: 'loading/set', payload: false});
        });
        const data = await response.data;
        data.piezas = data.piezas.map((pieza) => {
            return {
                ...pieza,
                fecha_almacenada: fechasAlmacenamiento.data?.find((fechaAlmacenamiento) => 
                    pieza.id_referencia_plataforma === fechaAlmacenamiento.id_referencia_plataforma
                )?.fecha_almacenada,
            }
        })
        dispatch({type: 'vehiculo/fullfilled', payload: {bastidor, vehiculo: data}});
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}